import React, { useState, useEffect } from "react";
import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleAbout = () => setAboutOpen(!aboutOpen);

  // Change navbar background on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const leftLinks = [
    { name: "Home", href: "/" },
    {
      name: "About",
      href: "#",
      submenu: [
        { name: "Our Story", href: "/about" },
        { name: "Founder", href: "/owner" },
      ],
    },
    { name: "Properties", href: "/projects" },
  ];

  const rightLinks = [
    { name: "Services", href: "/services" },
    { name: "Gallery", href: "/gallery" },
    { name: "Contact", href: "/contact" },
  ];

  const linkClasses = scrolled
    ? "text-gray-700 hover:text-blue-600"
    : "text-white hover:text-blue-300";

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 md:px-10 flex justify-between items-center py-4">
        {/* Left Links */}
        <div className="hidden md:flex items-center gap-8">
          {leftLinks.map((link, index) =>
            link.submenu ? (
              <div key={index} className="relative group">
                <button
                  onClick={toggleAbout}
                  className={`flex items-center gap-1 font-medium text-lg transition ${linkClasses}`}
                >
                  {link.name} <FiChevronDown />
                </button>
                {/* Submenu */}
                <div
                  className={`absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-lg overflow-hidden opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 ${
                    aboutOpen ? "opacity-100" : ""
                  }`}
                >
                  {link.submenu.map((sublink, i) => (
                    <a
                      key={i}
                      href={sublink.href}
                      className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition"
                    >
                      {sublink.name}
                    </a>
                  ))}
                </div>
              </div>
            ) : (
              <a key={index} href={link.href} className={`text-lg font-medium transition ${linkClasses}`}>
                {link.name}
              </a>
            )
          )}
        </div>

        {/* Logo */}
        <div className="flex justify-center items-center">
          <a href="/">
            <img
              src="/images/solonetproperties.png"
              alt="Solonet Logo"
              className="w-28 md:w-36 transition-all duration-300"
            />
          </a>
        </div>

        {/* Right Links */}
        <div className="hidden md:flex items-center gap-8">
          {rightLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              className={`text-lg font-medium transition ${linkClasses}`}
            >
              {link.name}
            </a>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMenu} className={`focus:outline-none ${scrolled ? "text-gray-800" : "text-white"}`}>
            {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className="md:hidden absolute top-16 left-0 w-full bg-white shadow-lg flex flex-col items-center py-6 gap-4 transition-all duration-300">
          {[...leftLinks, ...rightLinks].map((link, index) =>
            link.submenu ? (
              <div key={index} className="w-full flex flex-col items-center">
                <button
                  onClick={toggleAbout}
                  className="flex items-center justify-center gap-2 font-medium text-gray-700 text-lg"
                >
                  {link.name} <FiChevronDown />
                </button>
                {aboutOpen &&
                  link.submenu.map((sublink, i) => (
                    <a
                      key={i}
                      href={sublink.href}
                      className="block w-full text-center px-4 py-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 transition"
                      onClick={() => setIsOpen(false)}
                    >
                      {sublink.name}
                    </a>
                  ))}
              </div>
            ) : (
              <a
                key={index}
                href={link.href}
                className="text-lg font-medium text-gray-700 hover:text-blue-600"
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </a>
            )
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
